import React, { Component } from 'react';
import { Input, InputNumber, Spin, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import jquery from 'jquery';
import G6Editor from '@antv/g6-editor';
import DetailPanel from './DetailPanel';
import ContextMenu from './ContextMenu';
import ItemPanel from './ItemPanel';
import Page from './Page';
import './style.less';

G6Editor.track(false);

class FlowModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      selectedModel: {}, // 当前选中项数据模型
    };
  }

  toggleGrid(ev) {
    const editor = this.editor;
    const page = editor.getCurrentPage();
    if (ev.target.checked) {
      page.showGrid();
    } else {
      page.hideGrid();
    }
  }

  updateGraph(key, value) {
    const editor = this.editor;
    editor.executeCommand(() => {
      const page = editor.getCurrentPage();
      const selectedItems = page.getSelected();
      selectedItems.forEach(item => {
        const updateModel = {};
        updateModel[key] = value;
        page.update(item, updateModel);
      });
    });
  }

  componentWillMount() {
    this.editor = new G6Editor();
  }

  componentDidMount() {
    const editor = this.editor;
    const pages = editor.getComponentsByType('page');
    pages.forEach(page => {
      page.on('afteritemselected', ev => {
        this.setState({
          selectedModel: ev.item.getModel()
        }, () => {
          this.setState((prevState) => ({
            inputingLabel: prevState.selectedModel.label || null
          }));
        });
      });
    });
    const page = editor.getCurrentPage();
    page.changeAddEdgeModel({
      shape: 'flow-polyline-round'
    });
    this.queryData(this.props.params);
  }

  componentWillReceiveProps(nextProps) {
    const { isSave, isShow } = this.props;
    if (!isSave && nextProps.isSave) {
      this.save();
    }
    if (!isShow && nextProps.isShow) {
      this.queryData(nextProps.params);
    }
  }

  queryData = (params) => {
    const editor = this.editor;
    const page = editor.getCurrentPage();
    editor.executeCommand('resetZoom');
    page.read('{}');
    if (!params.ssuHospitalStructureId) {
      return;
    }
    this.setState({
      loading: true,
      selectedModel: {},
    });
    const options = {
      method: 'POST',
      url: API_URL.hospital.querySsuFlowChart,
      data: {
        ssuHospitalStructureId: params.ssuHospitalStructureId,
      },
      dataType: 'json',
      doneResult: res => {
        if (res.data) {
          page.read(JSON.parse(res.data.ssuFlowChartStartValue));
        }
        this.setState({ loading: false });
      },
    };
    $.sendRequest(options);
  }

  save = () => {
    const { params } = this.props;
    const newParams = {
      remark: params.remark,
      hospitalId: params.hospitalId,
      ssuModuleStructureId: params.ssuModuleStructureId,
      ssuModuleStructureDefineId: params.ssuModuleStructureDefineId,
    }
    if (params.ssuHospitalStructureId) {
      newParams.ssuHospitalStructureId = params.ssuHospitalStructureId;
    }

    const editor = this.editor;
    const page = editor.getCurrentPage();
    const startValue = page.save();
    newParams.startValue = JSON.stringify(startValue);

    const iframes = document.querySelectorAll('iframe');
    const iframesArray = iframes ? Array.from(iframes) : [];
    iframesArray.forEach(i => i.remove());

    editor.executeCommand('autoZoom');

    const canvas = jquery("#screenshots canvas")[0];
    const url = canvas.toDataURL("image/png");
    newParams.ssuFlowChartScreenshot = url;

    const options = {
      method: 'POST',
      url: API_URL.hospital.addSsuFlowChart,
      data: {
        ...newParams,
      },
      dataType: 'json',
      doneResult: res => {
        if (!res.error) {
          message.success(res.success);
          this.props.hide({
            [`${params.ssuModuleStructureDefineId}_flow`]: url,
          }, params.ssuModuleStructureDefineId, res.ssuHospitalStructureId);
        }
      },
      errorResult: () => {
        this.props.hide();
      }
    };
    $.sendRequest(options);
  }

  render() {
    const { loading, inputingLabel, selectedModel } = this.state;
    const splitSize = selectedModel.size ? selectedModel.size.split('*') : '';
    const width = splitSize[0];
    const height = splitSize[1];
    const showInput = !!Object.keys(selectedModel).length;
    let name;
    if (showInput) {
      if (selectedModel.type == 'node') {
        name = '节点文字';
      } else {
        name = '连接线文字';
      }
    }
    const labelInput = (
      <div className="p">
        <p>{name}</p>
        <Input
          size="small"
          className="input name-input"
          value={inputingLabel}
          onChange={ev => {
            this.setState({
              inputingLabel: ev.target.value
            });
          }}
          onBlur={ev => {
            this.updateGraph('label', ev.target.value);
            this.setState({
              selectedModel: {},
              inputingLabel: null,
            });
          }}
        />
      </div>
    );

    const isShow = selectedModel && selectedModel.shape != "flow-polyline-round";
    return (
      <Spin spinning={loading}>
        <div className="editor flowChartCommon">
          <div className="bottom-container">
            <ContextMenu editor={this.editor} />
            <ItemPanel editor={this.editor} content={
              <div style={{ paddingLeft: 15 }}>
                <div>
                  <img draggable="false" src="data:image/svg+xml;base64,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" data-type="node" data-shape="flow-rect" data-size="80*48" data-color="#1890FF" data-label="常规节点" className="getItem" />
                </div>
                <div>
                  <img draggable="false" src="data:image/svg+xml;base64,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" data-type="node" data-shape="flow-rhombus" data-size="80*72" data-color="#13C2C2" data-label="分支节点" className="getItem" />
                </div>
              </div>
            }
            />
            <DetailPanel
              editor={this.editor}
              content={
                <div>
                  <div data-status="node-selected" className="panel">
                    <div className="panel-title">属性</div>
                    {
                      showInput &&
                      <div className="block-container">
                        {labelInput}
                        {
                          isShow &&
                          <div className="p">
                            尺寸：
                            <InputNumber
                              size="small"
                              value={width} className="input width-input"
                              onChange={ value => {
                                const newSize = value + '*' + height;
                                selectedModel.size = newSize;
                                this.setState({
                                  selectedModel
                                });
                                this.updateGraph('size', newSize);
                              } }/>
                            <InputNumber
                              size="small"
                              value={height} className="input height-input"
                              onChange={ value => {
                                const newSize = width + '*' + value;
                                selectedModel.size = newSize;
                                this.setState({
                                  selectedModel
                                });
                                this.updateGraph('size', newSize);
                              } }/>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            />
            <Page editor={this.editor} />
          </div>
        </div>
      </Spin>
    )
  }
}

export default FlowModal


// WEBPACK FOOTER //
// ./src/components/common/flowChartCommon/index.js